import $ from "jquery";
import { initAhoyComponent } from "components/shared/ComponentInitializers/ComponentInitializers";
import { ComponentObserver } from "components/shared/ComponentObserver/ComponentObserver";
import { BugsnagAdapter } from "commons/BugsnagAdapter";

export default class LivestreamingRelated {
  constructor({ $element, element }) {
    this.$container = $element;
    this.container = element;
  }

  init() {
    let observer = new ComponentObserver("related-sidebar:onviewport");

    observer.observe(this.container);
    this.container.addEventListener(
      "vidio:related-sidebar:onviewport",
      this.loadData.bind(this)
    );
  }

  getUrl() {
    let schedule_id = this.container.dataset.scheduleId;
    let livestreaming_id = this.container.dataset.livestreamingId;

    return `/live/${livestreaming_id}/related/${schedule_id}.html`;
  }

  loadData() {
    let url = this.getUrl();

    $.get(url)
      .done((data) => {
        this.modifyElement(data);
      })
      .fail((e) => {
        console.error(e);
      });
  }

  modifyElement(element) {
    try {
      var el = $.parseHTML(element)[0];
      var $element = $(el);

      if (this.hasContent($element)) {
        this.$container.after($element);
        this.initJsAhoy($element);
      }

      this.$container.remove();
    } catch (e) {
      BugsnagAdapter.notify("LivestreamingRelated.modifyElement", e);
    }
  }

  hasContent($element) {
    return $element.find(".livestreaming-events__item").length > 0;
  }

  initJsAhoy($element) {
    let elements = $element.find(".js-ahoy");
    elements.push($element[0]);

    for (let i = 0; i < elements.length; i++) {
      initAhoyComponent(elements[i]);
    }
  }
}
